import React from 'react';
import ReaderList from './components/ReaderList';

const ReaderListPage: React.FC = () => {
  // Title is set at the application level
  return <ReaderList />;
};

export default ReaderListPage;